'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const BannerDisplay = renderWithRef('BannerDisplay', null, (n, a)=>{
    let { children: o } = n;
    return jsx(RenderComp, {
        root: "p",
        forwardedRef: a,
        classNames: [
            'swan-banner-display'
        ],
        props: n,
        children: o
    });
});

export { BannerDisplay };
